import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Gavetas from "./gavetas";
import api, { apiUrl } from "../services/requests";
import { Menu, Instagram, Facebook, Twitter, Linkedin } from "lucide-react";

const PaginaPrincipal = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const [resize, setResize] = useState(false);
  const [pesquisar, setPesquisar] = useState("");
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const mediaQuery = window.matchMedia("(max-width: 700px)");
  const verifySectionRef = useRef(null);

  const abrirMenu = () => {
    setOpenMenu(!openMenu);
  };

  const scrollToVerify = () => {
    if (verifySectionRef.current) {
      const headerHeight = 80; // Altura aproximada do header
      const elementPosition = verifySectionRef.current.offsetTop;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    if (mediaQuery.matches !== resize) {
      setResize(mediaQuery.matches);
    }
    const listener = () => {
      setResize(mediaQuery.matches);
    };
    mediaQuery.addEventListener("change", listener);
    return () => mediaQuery.removeEventListener("change", listener);
  }, [mediaQuery, resize]);

  const handleChange = async (e) => {
    setPesquisar(e.target.value.replace(/\D/g, ""));

    setError(false);
  };

  const handleClick = async () => {
    try {
      const { data } = await api.get(
        `/carteiras/pesquisar?elemento=${pesquisar}`
      );
      navigate(`/carteiras/${data.id}`);
    } catch (error) {
      setError(true);
      console.log(error);
    }
  };

  return (
    <>
      {/* Header com redes sociais */}
      <header className="flex items-center justify-end bg-blue-900 px-3 py-2 font-dosis text-xs font-semibold text-white mix-blend-difference">
        SIGA NOSSAS REDES SOCIAIS
        <a
          href="https://www.facebook.com/uniscestudantil"
          target="_blank"
          rel="noreferrer"
          className="ml-2.5"
        >
          <Facebook className="h-5 w-5 text-white" />
        </a>
        <a
          href="https://www.twitter.com/uniscestudantil"
          target="_blank"
          rel="noreferrer"
          className="ml-2.5"
        >
          <Twitter className="h-5 w-5 text-white" />
        </a>
        <a
          href="https://www.instagram.com/uniscestudantil"
          target="_blank"
          rel="noreferrer"
          className="ml-2.5"
        >
          <Instagram className="h-5 w-5 text-white" />
        </a>
        <a
          href="https://www.linkedin.com/company/uniscestudantil"
          target="_blank"
          rel="noreferrer"
          className="ml-2.5"
        >
          <Linkedin className="h-5 w-5 text-white" />
        </a>
      </header>

      {/* Container principal */}
      <div className="bg-gray-100 overflow-hidden">
        {/* Navegação */}
        <div className="flex items-center justify-between bg-gray-100">
          <div className="logo">
            <img
              src={`${apiUrl}/images/000065-01-l.png`}
              alt="logo"
              className="max-w-64 md:w-40"
            />
          </div>
          {resize ? (
            <>
              <Menu
                className="relative right-0 ml-2.5 h-9 w-9 border cursor-pointer"
                onClick={() => abrirMenu()}
              >
                Menu
              </Menu>
              {openMenu && (
                <div className="absolute right-0 top-20 z-10 bg-blue-900 md:right-0.5 md:top-22 md:flex md:text-xs">
                  <div className="z-10 flex">
                    <a
                      href="/painel"
                      className="m-1 font-sans text-white no-underline"
                    >
                      PAINEL
                    </a>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="flex flex-wrap">
              <a
                href="/painel"
                className="mx-5 font-sans font-normal text-blue-900 no-underline"
              >
                PAINEL
              </a>
            </div>
          )}
        </div>
        {/* Seção principal com fundo */}
        <div
          className="bg-cover bg-center bg-no-repeat bg-local"
          style={{
            backgroundImage: `url(https://api.uniscestudantil.org.br/images/fundo_pagina_inicial.jpg)`,
          }}
        >
          <div className="relative z-0 flex h-full w-full items-center before:absolute before:inset-0 before:z-[-1] before:bg-gradient-to-br before:from-teal-400/70 before:to-blue-800/70 lg:flex-row md:flex-col md:items-center md:justify-center flex-col items-center justify-center">
            {/* Conteúdo de texto */}
            <div className="relative z-10 flex w-full h-full flex-col items-center justify-around text-center lg:w-1/2 md:mt-5 md:w-full w-full">
              <h1 className="mb-12 font-arial-nova-cond text-2xl font-bold text-white lg:text-9xl md:text-6xl sm:text-4xl">
                PORTAL <br />
                UNISC ESTUDANTIL
              </h1>
              <h2 className="mb-12 whitespace-pre-line text-center font-arial-nova-cond text-sm font-bold text-white lg:text-3xl md:text-2xl sm:text-xl">
                Só na UNISC Estudantil <br />
                você tem atendimento <br />
                personalizado direto pelo <br />
                WhatsApp
              </h2>
              <button
                className="h-8 w-32 rounded-lg border-none bg-orange-500 text-white text-xs lg:h-12 lg:w-2/5 lg:text-base md:h-10 md:w-40 md:text-sm"
                onClick={scrollToVerify}
              >
                CONSULTAR CARTEIRA
              </button>
            </div>
            {/* Imagem da aluna */}
            <div className="m-0 h-[90%] w-[90%] lg:w-1/2 md:max-w-full md:self-center max-w-full self-center">
              <img
                src={`${apiUrl}/images/aluna_unisc.png`}
                alt="aluna"
                className="max-w-full"
              />
            </div>
          </div>
        </div>
        {/* Seção das carteiras */}
        <section
          className="flex w-full flex-col items-center bg-cover bg-center bg-no-repeat bg-local"
          style={{
            backgroundImage: `url(https://api.uniscestudantil.org.br/images/fundo_segunda_pagina.png)`,
          }}
        >
          <div className="mr-10 flex h-full items-center justify-center lg:flex-row md:flex-col md:w-full md:self-center flex-col w-full self-center">
            {/* Imagem da carteira */}
            <div className="z-0 mt-5 w-3/5 lg:w-3/5 md:ml-0 md:max-w-full w-full max-w-full">
              <img
                src={`${apiUrl}/images/carteira_2025_mobile.png`}
                alt="carteira"
                className="max-w-full"
              />
            </div>
            {/* Conteúdo das carteiras */}
            <div className="flex w-1/3 flex-col items-center justify-center text-center lg:w-1/3 md:w-full w-full">
              <h3 className="mb-4 text-center font-league-spartan text-lg font-bold text-gray-800 lg:text-6xl md:text-4xl sm:text-3xl">
                CARTEIRAS <br />
                FÍSICA E DIGITAL
              </h3>
              <ul className="mx-auto w-4/5 p-0 text-left font-bold text-gray-800 text-sm list-disc lg:text-4xl lg:ml-8 lg:w-2/3 lg:mx-0 md:ml-0 md:max-w-4/5 md:text-2xl md:mx-auto sm:text-xl sm:mx-auto">
                <li className="m-2.5 ml-4 p-0">Validade 31/03/2026.</li>
                <li className="m-2.5 ml-4 p-0">
                  Envio para todo o Brasil (correios).
                </li>
                <li className="m-2.5 ml-4 p-0">Suporte via WhatsApp.</li>
                <li className="m-2.5 ml-4 p-0">
                  Válida em todo território nacional.
                </li>
                <li className="m-2.5 ml-4 p-0">
                  Eventos culturais e esportivos.
                </li>
              </ul>
              <h3 className="mt-4 font-league-spartan text-lg font-bold text-gray-800 lg:text-6xl md:text-4xl sm:text-3xl">
                R$:50,00 + FRETE
              </h3>
            </div>
          </div>
          {/* Seção de atenção */}
          <div className="flex flex-col items-center justify-center md:mt-5 mt-5">
            <h3 className="m-0 self-center text-center font-roboto-condensed text-lg font-bold text-gray-800 lg:text-5xl md:text-3xl sm:text-2xl">
              Atenção
            </h3>
            <span className="my-4 p-0 text-center text-sm font-bold text-gray-800 lg:text-3xl md:text-xl sm:text-lg">
              A foto para carteira deve seguir o padrão para
              <br /> documento assim como nas carteiras de
              <br /> exemplo acima.
            </span>
          </div>
        </section>
        <section
          ref={verifySectionRef}
          id="verify"
          className="bg-gradient-to-r from-teal-400 to-blue-800"
          style={{
            background:
              "linear-gradient(90deg, rgb(93, 224, 230) 0%, rgb(0, 74, 173) 100%)",
          }}
        >
          <div className="flex items-center justify-center text-center lg:w-full lg:text-base w-full text-base">
            <h3 className="my-12 text-center font-league-spartan text-lg font-bold text-gray-800 lg:text-5xl lg:my-12 md:my-4 md:text-3xl sm:text-2xl">
              VERIFIQUE SUA CARTEIRA
            </h3>
          </div>
          <div className="my-12 flex items-center justify-center p-5 text-center lg:flex-row lg:w-full md:flex-col md:p-0 flex-col w-full p-0">
            <div className="flex flex-col items-center justify-center lg:w-1/2 md:w-full w-full">
              <p className="mb-12 w-3/4 p-0 font-arial-nova-cond text-sm font-bold text-gray-800 text-center lg:text-5xl lg:w-3/4 md:w-4/5 md:text-2xl sm:text-xl w-full">
                Preencha o campo abaixo <br />
                com <span className="text-red-500">CPF</span> ou{" "}
                <span className="text-red-500">Código de uso </span>
                contidos na carteira
              </p>
              <input
                placeholder="CPF / COD. DE USO"
                value={pesquisar}
                onChange={(e) => handleChange(e)}
                className="mb-4 h-8 w-4/5 rounded-lg border-4 border-orange-500 text-center text-xs outline-none lg:h-12 lg:w-1/2 lg:text-2xl md:mb-8 md:text-sm md:w-3/4 sm:w-4/5"
                style={{
                  border: "3px solid rgb(255, 139, 55)",
                  fontSize: "1.5vw",
                }}
              />
              {error && (
                <span className="mb-4 font-league-spartan text-lg font-extrabold text-black">
                  CARTEIRA NÃO ENCONTRADA!
                </span>
              )}
              <button
                className="mb-4 rounded-4xl border-none bg-orange-500 p-2 text-xs text-white shadow-lg rounded-2xl lg:p-4 lg:text-base md:p-2.5 md:text-xs"
                onClick={() => handleClick()}
                style={{ boxShadow: "0px 0px 2px 2px rgba(45, 45, 45, 0.3)" }}
              >
                CONSULTAR
              </button>
            </div>
            <div className="w-2/4 lg:w-2/5 md:max-w-11/12 sm:max-w-full w-full max-w-full">
              <img
                src={`${apiUrl}/images/UNISC_2025.png`}
                alt="carteira_principal"
                className="h-full w-full lg:rounded-lg lg:shadow-lg"
              />
            </div>
          </div>
          <div
            className="flex items-center justify-center pb-8 text-center font-league-spartan text-4xl font-black text-gray-800"
            style={{ fontSize: "2em" }}
          >
            {resize ? (
              <span
                className="w-4/5 self-center justify-self-center text-center text-2xl"
                style={{ fontSize: "1.3rem" }}
              >
                Nossa carteira deve ser consultada somente através do nosso site
              </span>
            ) : (
              <span>
                Nossa carteira deve ser consultada <br />
                somente através do nosso site
              </span>
            )}
          </div>
        </section>
        {/* Seção FAQ */}
        <section className="flex flex-col items-center justify-between w-full lg:flex-row">
          <div className="flex w-full flex-col items-center p-2.5 mb-4 lg:w-1/2 lg:mb-0">
            <img
              src={`${apiUrl}/images/icone_faq.png`}
              alt="faq"
              className="w-3/4 self-center lg:w-full lg:max-w-none lg:scale-100"
            />
          </div>
          <Gavetas />
        </section>

        {/* Footer */}
        <footer className="flex flex-col items-start justify-center bg-gray-300 max-h-72 lg:max-h-32 lg:flex-row lg:justify-between">
          <div className="m-4 flex items-center">
            <div className="flex flex-col justify-center">
              <p className="mt-0.5 font-roboto-condensed text-sm font-bold text-gray-600 text-[#6d8fab] lg:text-base">
                uniscestudantil@gmail.com
              </p>
            </div>
          </div>
          <div className="m-4 flex items-end justify-center mb-8 mt-8 min-w-3/4 max-w-3/4 justify-start self-start lg:items-end lg:justify-center lg:mb-4 lg:mt-4 lg:min-w-0 lg:max-w-none lg:justify-center lg:self-auto">
            <a
              className="mr-4 flex w-[10%] items-center rounded-md bg-black lg:w-[5%]"
              href="https://www.linkedin.com/company/uniscestudantil"
              target="_blank"
              rel="noreferrer"
            >
              <img src="./IN.svg" alt="linkedin" className="w-full" />
            </a>
            <a
              className="mr-4 flex w-[10%] items-center rounded-full bg-black lg:w-[5%]"
              href="https://www.facebook.com/uniscestudantil"
              target="_blank"
              rel="noreferrer"
            >
              <img src="./fb.svg" alt="facebook" className="w-full" />
            </a>
            <a
              className="mr-4 flex w-[10%] rounded-lg bg-black lg:w-[5%]"
              href="https://www.instagram.com/uniscestudantil"
              target="_blank"
              rel="noreferrer"
            >
              <img src="./insta.svg" alt="instagram" className="w-full" />
            </a>
            <a
              className="mr-4 flex w-[10%] items-center justify-center rounded-full bg-black lg:w-[5%]"
              href="https://www.twitter.com/uniscestudantil"
              target="_blank"
              rel="noreferrer"
            >
              <img src="./twitter.svg" alt="twitter" className="w-full" />
            </a>
          </div>
          <div className="m-4 flex flex-col text-left justify-center">
            <h3 className="m-0 font-roboto-condensed text-lg font-bold lg:text-xl">
              UNISC ESTUDANTIL
            </h3>
            <p className="m-0 font-roboto-condensed text-sm font-bold lg:text-base">
              UNIÃO ESTUDANTIL NACIONAL DE INCENTIVO SOCIAL E CULTURAL
            </p>
            <p className="m-0 font-roboto-condensed text-sm font-bold lg:text-base">
              CNPJ: 31.370.444/0001-42
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default PaginaPrincipal;
